export default __webpack_public_path__ + "static/media/About_BG-05.0fe3bab2.png";